export default __webpack_public_path__ + "static/media/svgIcons.sprite.a603a0bb.svg";